import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Productos from "./pages/Productos";
import SearchProductos from "./components/searchProductos"; 
import ProductDetail from "./pages/ProductDetail";
import Directorio from "./pages/Directorio";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import Nosotros from "./pages/Nosotros";
import Contacto from "./pages/Contacto";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Productos" element={<Productos />} />
        <Route path="/" element={<SearchProductos />} />
        <Route path="/producto/:id" element={<ProductDetail />} />
        <Route path="/Directorio-medico" element={<Directorio />} />
        <Route path="/Blogs" element={<Blogs />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/Sobre-nosotros" element={<Nosotros />} />
        <Route path="/Contacto" element={<Contacto />} />
      </Routes>
    </Router>
  );
}
